/* src/components/pages/Clientes.jsx - Modificado el 30-03-2026 */
/* --------------------- crud de clientes --------------------- */

import React, {
  useState,
  useEffect,
  useCallback
} from 'react';

import {
  Button,
  TextField,
  Box,
  Modal,
  Typography,
  Tooltip,
  Divider,
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';

import api from '../../services/api.js'; // Api Interceptor en vez de Axios

import { DataGrid } from "@mui/x-data-grid";
import { esES } from "@mui/x-data-grid/locales";
import { CustomToolbar } from "../../components/datagrid/CustomToolbar";
import DataGridSkeleton from "../../components/datagrid/DataGridSkeleton";

import {
  RiAddBoxLine,
  RiFolderDownloadLine,
  RiShareBoxFill,
  RiFileEditLine,
  RiDeleteBin6Line,
  RiSave3Fill,
  RiReplyAllLine,
  RiReplyAllFill
} from "react-icons/ri";

import { useAuth } from "../../context/AuthContext"; // token

/* Dialogo de confirmacion */
import { useFeedback } from '../../context/FeedbackContext'; // Mensajes breves

import { normalizeRut } from "../utils/rutUtils";
import { validarRut } from "../utils/rutValidator";


import { CSVLink } from 'react-csv';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';

const Clientes = ({ modo }) => {
  const { user } = useAuth();

  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [editingCliente, setEditingCliente] = useState(null);

  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState(''); // Para mostrar el mensaje de error cliente ya existe //

  const [id, setId] = useState(0);
  const [rutCli, setRutCli] = useState('');
  const [nombreCli, setNombreCli] = useState('');
  const [direccionCli, setDireccionCli] = useState('');
  const [comunaCli, setComunaCli] = useState('');
  const [ciudadCli, setCiudadCli] = useState('');
  const [telefonoCli, setTelefonoCli] = useState('');
  const [emailCli, setEmailCli] = useState('');
  const [clavesiiCli, setClavesiiCli] = useState('');
  const [claveunicaCli, setClaveunicaCli] = useState('');
  const [banco1Cli, setBanco1Cli] = useState('');
  const [banco2Cli, setBanco2Cli] = useState('');
  const [banco3Cli, setBanco3Cli] = useState('');
  const [ctacte1Cli, setCtacte1Cli] = useState('');
  const [ctacte2Cli, setCtacte2Cli] = useState('');
  const [ctacte3Cli, setCtacte3Cli] = useState('');

  const [bancos, setBancos] = useState([]);
  const [isFormValid, setIsFormValid] = useState(false);

  /* Dialogo y confirmación */
  const { showFeedback } = useFeedback(); // Mensajes breves no bloqueantes
  
  /* Función para cancelar y limpiar los arreglos */
  const handleCancel = () => {
    setClientes([]);
    fetchClientes();
   };

  /* Validación de formato de email */
  const validarEmail = (email) => {
    // Expresión regular para validar el formato del email
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  // cargar todos los registros de la tabla clientes //
  const fetchClientes = useCallback(async () => {
    try {

      setLoading(true);

      const response = await api.post('/clientes/getclientes');

      if (response.data.success && response.data.rows) {
        setClientes(response.data.rows);

      } else {
        setClientes([]);
      }
      
    } catch (error) {
      setClientes([]); // También limpiar en caso de error de red
    } finally {
      setLoading(false);
    }
  }, [setClientes]);

  /* llamar a cargar clientes */
  useEffect(() => {
    fetchClientes();
  }, [fetchClientes]);

  /* cargar bancos desde tabla bancos */
  const fetchBancos = useCallback(async () => {
    try {

      const response = await api.post('/registrarse/getbancos', {
        idBan: 0
      });

      if (response.data.success && response.data.rows) {
        setBancos(response.data.rows);
      } else {
        setBancos([]);
      }

    } catch (error) {
      setBancos([]);
    }
  }, []);

  /* carga los bancos */
  useEffect(() => {
    fetchBancos();
  }, [fetchBancos]);

  /* Validar bancos y ctasctes */
  const validateBankPair = (banco, cuenta, idx, newErrors) => {
    const bancoKey = `banco${idx}Cli`;
    const cuentaKey = `ctacte${idx}Cli`;

    newErrors[bancoKey] = '';
    newErrors[cuentaKey] = '';

    const cuentaValida = cuenta && cuenta.trim() !== '';
    const bancoValido = banco

    if (bancoValido && !cuentaValida) {
      newErrors[cuentaKey] = `Debe ingresar la Ctacte ${idx}`;
    } else if (!bancoValido && cuentaValida) {
      newErrors[bancoKey] = `Debe seleccionar el Banco ${idx}`;
    }
  };

  /* Manejo de cambio y validaciones de input */
  const handleInputChange = async (e, fieldName) => {
    const { value } = e.target;
    let newErrors = { ...errors };

    switch (fieldName) {
      case 'rutCli':
        setRutCli(value);
        newErrors.rutCli = '';

        if (!value.trim()) {
          setMessage('');
          newErrors.rutCli = '';
          break;
        }

        if (!validarRut(value)) newErrors.rutCli = 'El Rut ingresado no es válido';
        else {
          setMessage('');
          try {
            const fixRutCli = value.padStart(10, '0');
            const rutExists = await checkRutExists(fixRutCli);
            if (rutExists) {
              setMessage('El Rut ingresado ya existe');
            } else {
              setMessage('');
            }
          } catch {
            setMessage('Hubo un problema al verificar el RUT');
          }
        }
        break;

      case 'nombreCli':
        setNombreCli(value);
        newErrors.nombreCli = value.trim() === '' ? 'Debe ingresar el nombre' : '';
        break;
  
      case 'direccionCli':
        setDireccionCli(value);
        newErrors.direccionCli = value.trim() === '' ? 'Debe ingresar la dirección' : '';
        break;

      case 'comunaCli':
        setComunaCli(value);
        newErrors.comunaCli = value.trim() === '' ? 'Debe ingresar la comuna' : '';
        break;

      case 'ciudadCli':
        setCiudadCli(value);
        newErrors.ciudadCli = value.trim() === '' ? 'Debe ingresar la ciudad' : '';
        break;

      case 'telefonoCli':
        setTelefonoCli(value);
        newErrors.telefonoCli = value.trim() === '' ? 'Debe ingresar el teléfono' : '';
        break;

      case 'emailCli':
        setEmailCli(value);
        newErrors.emailCli =
          value.trim() === '' || !validarEmail(value) ? 'El email ingresado no es válido' : '';
        break;

      case 'clavesiiCli':
        setClavesiiCli(value);
        newErrors.clavesiiCli = value.trim() === '' ? 'Debe ingresar la clave del SII' : '';
        break;

      case 'claveunicaCli':
        setClaveunicaCli(value);
        newErrors.claveunicaCli = '';
        break;

      /* ---------- Bancos y Ctacte ---------- */
      case 'banco1Cli':
        setBanco1Cli(value);
        break;
      case 'ctacte1Cli':
        setCtacte1Cli(value);
        break;
      case 'banco2Cli':
        setBanco2Cli(value);
        break;
      case 'ctacte2Cli':
        setCtacte2Cli(value);
        break;
      case 'banco3Cli':
        setBanco3Cli(value);
        break;
      case 'ctacte3Cli':
        setCtacte3Cli(value);
        break;

      default:
        break;
    }

    /* Validación bancos/cuentas con valores actualizados */
    validateBankPair(
      fieldName === 'banco1Cli' ? value : banco1Cli,
      fieldName === 'ctacte1Cli' ? value : ctacte1Cli,
      1,
      newErrors
    );

    validateBankPair(
      fieldName === 'banco2Cli' ? value : banco2Cli,
      fieldName === 'ctacte2Cli' ? value : ctacte2Cli,
      2,
      newErrors
    );

    validateBankPair(
      fieldName === 'banco3Cli' ? value : banco3Cli,
      fieldName === 'ctacte3Cli' ? value : ctacte3Cli,
      3,
      newErrors
    );

    /* Validación global */
    const hasErrors = Object.values(newErrors).some(err => err && err !== '');
    const requiredFields = [
      rutCli,
      fieldName === 'nombreCli' ? value : nombreCli,
      fieldName === 'direccionCli' ? value : direccionCli,
      fieldName === 'comunaCli' ? value : comunaCli,
      fieldName === 'ciudadCli' ? value : ciudadCli,
      telefonoCli,
      emailCli,
      fieldName === 'clavesiiCli' ? value : clavesiiCli
    ];
    const hasEmptyFields = requiredFields.some(field => !field || field.trim() === '');

    setErrors(newErrors);
    setIsFormValid(!hasErrors && !hasEmptyFields);
  };


  /* Verificar si el RUT ya existe en la base de datos */
  const checkRutExists = async (rut) => {
    try {
      setMessage('');

      const RutCli = normalizeRut(user.usuario)

      const response = await api.post('/clientes/checkrut', {
        RutCli
      });

      return response.data.success;

    } catch (error) {
      return false;
    }
  };

  /* Agregar o Editar Cliente */
  const handleSave = async () => {
    const validationErrors = {};
    setMessage('');

    if (!rutCli) validationErrors.rutCli = 'El Rut es obligatorio';
    if (!nombreCli) validationErrors.nombreCli = 'El Nombre es obligatorio';
    if (!direccionCli) validationErrors.direccionCli = 'La Dirección es obligatoria';
    if (!comunaCli) validationErrors.comunaCli = 'La Comuna es obligatoria';
    if (!ciudadCli) validationErrors.ciudadCli = 'La Ciudad es obligatoria';
    if (!telefonoCli) validationErrors.telefonoCli = 'El Teléfono es obligatorio';
    if (!emailCli) validationErrors.emailCli = 'El Email es obligatorio';

    if (banco1Cli) {
      if (!ctacte1Cli) {
        validationErrors.ctacte1Cli = 'Debe ingresar Ctacte 1';
      }
    }
    if (ctacte1Cli) {
      if (!banco1Cli) {
        validationErrors.banco1Cli = 'Debe seleccionar el Banco 1';
      }
    }

    if (banco2Cli) {
      if (!ctacte2Cli) {
        validationErrors.ctacte2Cli = 'Debe ingresar Ctacte 2';
      }
    }
    if (ctacte2Cli) {
      if (!banco2Cli) {
        validationErrors.banco2Cli = 'Debe seleccionar el Banco 2';
      }
    }

    if (banco3Cli) {
      if (!ctacte3Cli) {
        validationErrors.ctacte1Cli = 'Debe ingresar Ctacte 3';
      }
    }
    if (ctacte3Cli) {
      if (!banco3Cli) {
        validationErrors.banco3Cli = 'Debe seleccionar el Banco 3';
      }
    }

    /* Validación de formato de email */
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (emailCli && !emailRegex.test(emailCli)) {
      validationErrors.emailCli = 'El Email no es válido';
    }
    
    if (!validarRut(rutCli)) {
      validationErrors.rutCli = 'El Rut no es válido';
    } else {
      setMessage('');
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const fixRutCli = rutCli.padStart(10, '0');
    const upperNombreCli = nombreCli.toUpperCase();
    const upperDireccionCli = direccionCli.toUpperCase();
    const upperComunaCli = comunaCli.toUpperCase();
    const upperCiudadCli = ciudadCli.toUpperCase();
    const lowerEmailCli = emailCli.toLowerCase();

    /* update del registro */
    try {
      if (editingCliente) {

        await api.post('/clientes/updatecliente', {
          id_cli: id,
          rut_cli: fixRutCli,
          nombre_cli: upperNombreCli,
          direccion_cli: upperDireccionCli,
          comuna_cli: upperComunaCli,
          ciudad_cli: upperCiudadCli,
          telefono_cli: telefonoCli,
          email_cli: lowerEmailCli,
          clavesii_cli: clavesiiCli,
          claveunica_cli: claveunicaCli,
          banco1_cli: banco1Cli,
          ctacte1_cli: ctacte1Cli,
          banco2_cli: banco2Cli,
          ctacte2_cli: ctacte2Cli,
          banco3_cli: banco3Cli,
          ctacte3_cli: ctacte3Cli
        });

        /* insert registro */
      } else {
        /* Verificar si el RUT ya existe en la base de datos */
        const rutExists = await checkRutExists(fixRutCli);

        /* Revisar si el campo success en la respuesta es true */
        if (rutExists) {
          /* Si el servidor responde que la validacion no fue exitosa */
          setMessage('Cliente Ya Existe.');
          setErrors({});
          return;
        }

        await api.post('/clientes/addcliente', {
          rut_cli: fixRutCli,
          nombre_cli: upperNombreCli,
          direccion_cli: upperDireccionCli,
          comuna_cli: upperComunaCli,
          ciudad_cli: upperCiudadCli,
          telefono_cli: telefonoCli,
          email_cli: lowerEmailCli,
          clavesii_cli: clavesiiCli,
          claveunica_cli: claveunicaCli,
          banco1_cli: banco1Cli,
          ctacte1_cli: ctacte1Cli,
          banco2_cli: banco2Cli,
          ctacte2_cli: ctacte2Cli,
          banco3_cli: banco3Cli,
          ctacte3_cli: ctacte3Cli,
          uniqueId: ''
        });
      }

      if (editingCliente) {
        showFeedback({
          message: 'El cliente fue actualizado correctamente.',
          severity: 'success',
        });
      } else {
        showFeedback({
          message: 'El cliente fue grabado correctamente.',
          severity: 'success',
        });
      };

      fetchClientes();
      handleCloseModal();

    } catch (error) {
      showFeedback({
        message: 'Hubo un problema al procesar la solicitud, intente más tarde.',
        severity: 'error',
      });
    }
  };

  /* eliminar registro */
  const handleDelete = async (id, rut, nombre) => {
    const result = await Swal.fire({
      title: "¿Está seguro de eliminar?",
      footer: '▶️ Overwatch',
      allowOutsideClick: false,  // 👈 evita cierre con click afuera
      background: 'rgba(30, 41, 59, 0.9)', // equilibrio entre opaco y transparente
      color: '#f8fafc',
      customClass: {
        popup: 'swal-custom-popup',
        title: 'swal-custom-title',
        htmlContainer: 'swal-custom-text'
      },

      html: `
        <b>Rut: ${rut}</b><br>
        <b>Nombre: ${nombre}</b>
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar!",
      cancelButtonText: "Cancelar"
    });
  
    if (result.isConfirmed) {
      try {
    
        await api.post('/clientes/deletecliente', {
          id_cli: id
        });

        showFeedback({
          message: 'El cliente fue eliminado correctamente.',
          severity: 'success',
        });

        fetchClientes();
        
      } catch (error) {
        showFeedback({
          message: 'Hubo un problema al procesar la solicitud, intente más tarde.',
          severity: 'error',
        });
      }
    }
  };
  
  /* Abrir Modal para Editar Cliente */
  const handleEdit = (cliente) => {
    setId(cliente.id_cli);
    setRutCli(cliente.rut_cli);
    setNombreCli(cliente.nombre_cli);
    setDireccionCli(cliente.direccion_cli);
    setComunaCli(cliente.comuna_cli);
    setCiudadCli(cliente.ciudad_cli);
    setTelefonoCli(cliente.telefono_cli);
    setEmailCli(cliente.email_cli);
    setClavesiiCli(cliente.clavesii_cli);
    setClaveunicaCli(cliente.claveunica_cli);
    setBanco1Cli(cliente.banco1_cli === 0 ? '' : cliente.banco1_cli);
    setBanco2Cli(cliente.banco2_cli === 0 ? '' : cliente.banco2_cli);
    setBanco3Cli(cliente.banco3_cli === 0 ? '' : cliente.banco3_cli);
    setCtacte1Cli(cliente.ctacte1_cli);
    setCtacte2Cli(cliente.ctacte2_cli);
    setCtacte3Cli(cliente.ctacte3_cli);
    setEditingCliente(cliente);
    setMessage('');
    setOpen(true);

     /* Limpiar el error de todos los input */
     setErrors(prevErrors => ({
      ...prevErrors,
      id: 0,
      rutCli: '',
      nombreCli: '',
      direccionCli: '',
      comunaCli: '',
      ciudadCli: '',
      telefonoCli: '',
      emailCli: '',
      banco1_cli:  '',
      ctacte1_cli:  '',
      banco2_cli:  '',
      ctacte2_cli:  '',
      banco3_cli:  '',
      ctacte3_cli:  ''
    }));
  };

  /* Abrir Modal para Crear Cliente */
  const handleAdd = () => {
    setRutCli('');
    setNombreCli('');
    setDireccionCli('');
    setComunaCli('');
    setCiudadCli('');
    setTelefonoCli('');
    setEmailCli('');
    setClavesiiCli('');
    setClaveunicaCli('');
    setBanco1Cli('');
    setBanco2Cli('');
    setBanco3Cli('');
    setCtacte1Cli('');
    setCtacte2Cli('');
    setCtacte3Cli('');
    setEditingCliente(null);
    setMessage('');
    setOpen(true);

    /* Limpiar el error de todos los input */
    setErrors(prevErrors => ({
      ...prevErrors,
      rutCli: '',
      nombreCli: '',
      direccionCli: '',
      comunaCli: '',
      ciudadCli: '',
      telefonoCli: '',
      emailCli: '',
      banco1_cli: '',
      banco2_cli: '',
      banco3_cli: '',
      ctacte1_cli: '',
      ctacte2_cli: '',
      ctacte3_cli: ''
    }));
  };

  /* estado para modal */
  const handleCloseModal = () => setOpen(false);

  /* exportar a pdf todos los datos de la tabla */
  const logo = new Image();
  logo.src = '/Overwatch.jpg'; // Ruta del logo */
  
  const exportToPDF = () => {
      const doc = new jsPDF('landscape');

      // Añadir logo //
      const logoX = 5; // Posición X del logo //
      const logoY = 5; // Posición Y del logo //
      doc.addImage(logo, "JPEG", logoX, logoY, 60, 10);
  
      // Fecha y página alineados a la derecha //
      doc.setFontSize(10);
      const fecha = `Fecha: ${new Date().toLocaleDateString()}`;
      const pagina = `Página 1 de 1`;
      const pageWidth = doc.internal.pageSize.width;
  
      // Calcular posición de la fecha y la página //
      const fechaX = pageWidth - doc.getTextWidth(fecha) - 5; // 10 de margen //
      const paginaX = pageWidth - doc.getTextWidth(pagina) - 5; // 10 de margen //
  
      // Colocar fecha y página en la misma línea que el logo //
      const textY = logoY + 10; // Alinear verticalmente con el logo //
      const paginaY = textY + 5; // Colocar la paginación 5 unidades más abajo //
  
      doc.text(fecha, fechaX, textY);
      doc.text(pagina, paginaX, paginaY); // Usar nueva posición Y para la paginación //
  
      // Título //
      doc.setFontSize(18);
      doc.text('Listado de Clientes', 120, 25); // horizontal, vertical //
  
      // Tabla de clientes //
      doc.autoTable({
          head: [['RUT', 'NOMBRE','DIRECCIÓN','COMUNA','CIUDAD','TELÉFONO','EMAIL']],
          body: clientes.map((cliente) => [
            cliente.rut_cli,
            cliente.nombre_cli,
            cliente.direccion_cli,
            cliente.comuna_cli,
            cliente.ciudad_cli,
            cliente.telefono_cli,
            cliente.email_cli ]),
          foot: [['Total', clientes.length]],
          startY: 30, // Comenzar la tabla después de los encabezados //
          styles: {
              fontSize: 12,
              cellPadding: 3,
              halign: 'center',
          },
          headStyles: {
              fillColor: [22, 160, 133], // Color de encabezado //
              textColor: [255, 255, 255], // Color de texto en encabezado //
          },
          footStyles: {
              fillColor: [22, 160, 133], // Color de pie de página //
              textColor: [255, 255, 255], // Color de texto en pie de página //
          },
      });
  
      // Total de registros //
      doc.text(`Registros: ${clientes.length}`, 10, doc.internal.pageSize.height - 10);
      doc.save('clientes.pdf');
  };
  
  logo.onerror = () => {
      console.error('Error al cargar la imagen del logo.', logo.src);
  };

  
  /* Mostrar columnas en MaterialReactTable */
  const columns = [
    {
      field: 'actions',
      headerName: 'Acciones',
      width: 100,
      sortable: false,
      filterable: false,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => {
        const row = params.row;

        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            
            {/* --- Botón Editar (Azul) --- */}
            <Tooltip title="Editar" placement="top" arrow>
              <Button
                onClick={() => handleEdit(row)}
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: '#1E88E5',    // azul
                  color: 'white',                // icono blanco
                  minWidth: 0,
                  padding: 0,
                  width: 30,
                  height: 22,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  '&:hover': {
                    backgroundColor: '#1565C0', // azul más oscuro
                  },
                }}
              >
                <RiFileEditLine size={18} />
              </Button>
            </Tooltip>

            {/* --- Botón Eliminar (Rojo) --- */}
            <Tooltip title="Eliminar" placement="top" arrow>
              <Button
                onClick={() => handleDelete(row.id_cli, row.rut_cli, row.nombre_cli)}
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: '#E53935',   // rojo
                  color: 'white',               // icono blanco
                  minWidth: 0,
                  padding: 0,
                  width: 30,
                  height: 22,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  '&:hover': {
                    backgroundColor: '#C62828', // rojo más oscuro
                  },
                }}
              >
                <RiDeleteBin6Line size={18} />
              </Button>
            </Tooltip>

          </div>
        );
      },
      headerClassName: 'acciones-header',
    },
    {
      field: 'id_cli',
      width: 80,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => (
        <Tooltip title="Id del Registro" arrow
          placement="top"
        >
        <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              fontWeight: 'bold',
              cursor: 'help',
            }}
          >
            Id
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'rut_cli',
      headerName: "Rut",
      width: 130,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => (
        <Tooltip title="Rut del Cliente" arrow
          placement="top"
        >
        <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              fontWeight: 'bold',
              cursor: 'help',
            }}
          >
            Rut
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'nombre_cli',
      headerName: "Nombre",
      width: 300,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => (
        <Tooltip title="Nombre del Cliente" arrow
          placement="top"
        >
        <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              fontWeight: 'bold',
              cursor: 'help',
            }}
          >
            Nombre
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'direccion_cli',
      headerName: "Dirección",
      width: 300,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => (
        <Tooltip title="Dirección del Cliente" arrow
          placement="top"
        >
        <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              fontWeight: 'bold',
              cursor: 'help',
            }}
          >
            Dirección
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'comuna_cli',
      headerName: "Comuna",
      width: 200,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => (
        <Tooltip title="Comuna del Cliente" arrow
          placement="top"
        >
        <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              fontWeight: 'bold',
              cursor: 'help',
            }}
          >
            comuna
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'ciudad_cli',
      headerName: "Ciudad",
      width: 200,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => (
        <Tooltip title="Ciudad del Cliente" arrow
          placement="top"
        >
        <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              fontWeight: 'bold',
              cursor: 'help',
            }}
          >
            Ciudad
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'telefono_cli',
      headerName: "Teléfono",
      width: 200,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => (
        <Tooltip title="Teléfono del Cliente" arrow
          placement="top"
        >
        <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              fontWeight: 'bold',
              cursor: 'help',
            }}
          >
            Teléfono
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'email_cli',
      headerName: "Email",
      width: 200,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => (
        <Tooltip title="Email del Cliente" arrow
          placement="top"
        >
        <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              fontWeight: 'bold',
              cursor: 'help',
            }}
          >
            Email
          </span>
        </Tooltip>
      ),
    },
  ];

  // render de los datos //
  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          gap: 1,
          alignItems: 'center',
          mt: 2,
          mb: 1,
          height: '70px',
          flexWrap: 'wrap', // Permite que los elementos se acomoden en múltiples líneas si es necesario
          maxWidth: '100%',
        }}
      >
        <Tooltip title="Agregar Nuevo Registro" placement="top" arrow>
          <Button variant="contained"
            onClick={handleAdd}
            sx={{
              width: '160px',
              height: '40px',
              textTransform: 'none',
              backgroundColor: '#8b888e', // Color de fondo inicial
              color: 'white', // Color del texto en blanco
              '&:hover': {
                backgroundColor: '#65a76c', // Cambia el color de fondo a verde al pasar el mouse //
                color: 'white', // Cambia el color del texto a blanco //
              }
            }}
          >
            <RiAddBoxLine className="m-2" style={{ fontSize: '1.5rem' }} />
            Agregar
          </Button>
        </Tooltip>

        {/* Botón Cancelar */}
        <Tooltip title="Cancelar Todo" placement="top" arrow>
          <Button
            variant="contained"
            onClick={handleCancel}
            sx={{
              width: '180px',
              height: '40px',
              textTransform: 'none',
              backgroundColor: '#8b888e', // Color de fondo para cancelar
              color: 'white',
              '&:hover': {
                backgroundColor: '#b9770e', // Color al pasar el cursor //
                color: 'white',
              },
              '& .MuiButton-startIcon': {
                color: 'white',
              },
            }}
          >
            {/* Icono de cancelar */}
            <RiReplyAllFill className="m-2" style={{ fontSize: '1.5rem' }} />
            Cancelar
          </Button>
        </Tooltip>

        <Tooltip title="Exportar a Pdf" placement="top" arrow>
          <span>
            <Button
              variant="contained"
              disabled={clientes.length ===0}
              onClick={exportToPDF}
              sx={{
                width: '100px',
                height: '40px',
                backgroundColor: '#8b888e', // Color de fondo inicial
                color: 'white', // Color del texto en blanco
                '&:hover': {
                  backgroundColor: '#65a76c', // Cambia el color de fondo a verde al pasar el mouse //
                  color: 'white', // Cambia el color del texto a blanco //
                }
              }}
            >
            <RiFolderDownloadLine className="m-2" style={{ fontSize: '1.5rem' }} /> {/* Aumento el tamaño del icono */}
              PDF
            </Button>
          </span>
        </Tooltip>

        <Tooltip title="Exportar a Csv" placement="top" arrow>
          <span>
            <Button
              variant="contained"
              disabled={clientes.length ===0}
              sx={{
                width: '100px',
                height: '40px',
                backgroundColor: '#8b888e', // Color de fondo inicial
                color: 'white', // Color del texto en blanco
                '&:hover': {
                  backgroundColor: '#65a76c', // Cambia el color de fondo a verde al pasar el mouse //
                  color: 'white', // Cambia el color del texto a blanco //
                }
              }}
            >
              <RiShareBoxFill className="m-2" style={{ fontSize: '1.5rem' }} /> {/* Aumento el tamaño del icono */}
              <CSVLink data={clientes} filename="clientes.csv">
                CSV
              </CSVLink>
            </Button>
          </span>
        </Tooltip>

        {/* Configuración MIU DataGrid */}
        <Box
          sx={{
            flexGrow: 1,        // 👈 ocupa el resto del espacio
            minHeight: 300,     // 👈 altura mínima usable
            width: '100%',
            overflow: 'hidden', // 👈 DataGrid maneja su scroll
          }}
        >
          <DataGrid
            rows={clientes}
            columns={columns}
            getRowId={(row) => row.id_cli}
            loading={loading}
            density="compact"
            rowHeight={38}
            headerHeight={40}
            pagination
            disableRowSelectionOnClick
            initialState={{
              pagination: { paginationModel: { pageSize: 10, page: 0 } },
              density: 'compact',
            }}
            pageSizeOptions={[10, 20, 50, 100]}
            localeText={esES.components.MuiDataGrid.defaultProps.localeText}
            slots={{
              toolbar: CustomToolbar,
              loadingOverlay: DataGridSkeleton,
            }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 400 },
              },
            }}
            sx={{
              height: '100%',
              width: '100%',
              minWidth: 720,      // scroll horizontal cuando corresponde
              border: 'none',
              // accesibilidad / foco
              '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                outline: 'none',
              },
            }}
          />
        </Box>


        {/* Modal para ingresar o modificar */}
        <Modal
          open={open}
            onClose={(event, reason) => {
              // Solo cerrar si el motivo NO es 'backdropClick' ni 'escapeKeyDown'
              if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                handleCloseModal();
              }
            }}
            >

          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '600px',           // ancho fijo en desktop
              maxWidth: '95vw',         // se ajusta en pantallas pequeñas
              maxHeight: '90vh',        // límite de alto
              boxShadow: 24,
              p: 3,
              overflowY: 'auto',        // 👈 habilita scroll vertical
              borderRadius: 2,          // opcional: bordes redondeados
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold'}}>
                {editingCliente ? 'Editando Cliente' : 'Agregando Cliente'}
              </Typography>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold'}}>
                ▶️ Overwatch
              </Typography>
            </Box>

            <Divider sx={{ marginY: 2 }} />
            <div className="mb-4" /> {/* Esta línea añade un margen inferior */}

            {/* Mostrar mensaje de error si existe */}
            {message && (
              <Typography color="error" sx={{ marginBottom: 2 }}>
                {message}
              </Typography>
            )}

            {/* RUT */}
            <TextField
              label="Rut"
              value={rutCli}
              onChange={(e) => handleInputChange(e, 'rutCli')}
              fullWidth
              sx={{
                marginBottom: 2,
                '& .MuiInputBase-root': {
                  height: 40,
                },
              }}
              error={Boolean(errors.rutCli)}
              helperText={errors.rutCli}
              disabled={Boolean(editingCliente)} // Deshabilitar si estamos editando un cliente //
              autoComplete="off" // Desactivar autocompletado //
            />

            {/* NOMBRE */}
            <TextField
              label="Nombre"
              value={nombreCli}
              onChange={(e) => handleInputChange(e, 'nombreCli')}
              fullWidth
              sx={{
                marginBottom: 2,
                '& .MuiInputBase-root': {
                  height: 40,
                },
              }}
              error={Boolean(errors.nombreCli)}
              helperText={errors.nombreCli}
              autoComplete="off" // Desactivar autocompletado //
              autoFocus // Agregar enfoque al cargar el componente //
            />

            {/* DIRECCION */}
            <TextField
              label="Dirección"
              value={direccionCli}
              onChange={(e) => handleInputChange(e, 'direccionCli')}
              fullWidth
              sx={{
                marginBottom: 2,
                '& .MuiInputBase-root': {
                  height: 40,
                },
              }}
              error={Boolean(errors.direccionCli)}
              helperText={errors.direccionCli}
              autoComplete="off" // Desactivar autocompletado //
            />

            <div className="mt-4 flex gap-4 justify-between text-sm text-teal-200">
              {/* COMUNA */}
              <TextField
                label="Comuna"
                value={comunaCli}
                onChange={(e) => handleInputChange(e, 'comunaCli')}
                fullWidth
                sx={{
                  marginBottom: 2,
                  '& .MuiInputBase-root': {
                    height: 40,
                  },
                }}
                error={Boolean(errors.comunaCli)}
                helperText={errors.comunaCli}
                autoComplete="off" // Desactivar autocompletado //
              />

              {/* CIUDAD */}
              <TextField
                label="Ciudad"
                value={ciudadCli}
                onChange={(e) => handleInputChange(e, 'ciudadCli')}
                fullWidth
                sx={{
                  marginBottom: 2,
                  '& .MuiInputBase-root': {
                    height: 40,
                  },
                }}
              error={Boolean(errors.ciudadCli)}
                helperText={errors.ciudadCli}
                autoComplete="off" // Desactivar autocompletado //
              />
            </div>

            {/* TELEFONO */}
            <TextField
              label="Teléfono"
              value={telefonoCli}
              onChange={(e) => handleInputChange(e, 'telefonoCli')}
              fullWidth
              sx={{
                marginBottom: 2,
                '& .MuiInputBase-root': {
                  height: 40,
                },
              }}
              error={Boolean(errors.telefonoCli)}
              helperText={errors.telefonoCli}
              autoComplete="off" // Desactivar autocompletado //
            />

            {/* EMAIL */}
            <TextField
              label="Email"
              value={emailCli}
              onChange={(e) => handleInputChange(e, 'emailCli')}
              fullWidth
              sx={{
                marginBottom: 2,
                '& .MuiInputBase-root': {
                  height: 40,
                },
              }}
              error={Boolean(errors.emailCli)}
              helperText={errors.emailCli}
              autoComplete="off" // Desactivar autocompletado //
            />

            <div className="mt-4 flex gap-4 justify-between text-sm text-teal-200">
              {/* CLAVE SII */}
              <TextField
                label="Clave Sii"
                value={clavesiiCli}
                onChange={(e) => handleInputChange(e, 'clavesiiCli')}
                fullWidth
                sx={{
                  marginBottom: 2,
                  '& .MuiInputBase-root': {
                    height: 40,
                  },
                }}
                error={Boolean(errors.clavesiiCli)}
                helperText={errors.clavesiiCli}
                autoComplete="off" // Desactivar autocompletado //
              />

              {/* CLAVE UNICA */}
              <TextField
                label="Clave Única"
                value={claveunicaCli}
                onChange={(e) => handleInputChange(e, 'claveunicaCli')}
                fullWidth
                sx={{
                  marginBottom: 2,
                  '& .MuiInputBase-root': {
                    height: 40,
                  },
                }}
                error={Boolean(errors.claveunicaCli)}
                helperText={errors.claveunicaCli}
                autoComplete="off" // Desactivar autocompletado //
              />
            </div>

            <div className="mt-4 flex gap-4 justify-between text-sm text-teal-200">
              {/* Banco 1 */}
              <FormControl
                fullWidth
                // required
                error={Boolean(errors.banco1Cli)}
                sx={{ width: '300px' }}
              >
                <InputLabel id="banco1-label" sx={{ marginTop: '2px' }}>
                  Banco-1
                </InputLabel>

                <Select
                  labelId="banco1-label"
                  id="banco1-select"
                  value={banco1Cli}
                  label="Banco"
                  onChange={(e) => handleInputChange(e, 'banco1Cli')}
                  sx={{
                    height: 40,

                  }}
                  // opcional: aria-describedby para accesibilidad
                  aria-describedby="banco1-helper"
                >
                  <MenuItem 
                    value={''} 
                    sx={{ color: '#5A47B3', fontWeight: 'bold' }}
                  >
                    ✨ Seleccionar Banco
                  </MenuItem>
                  {bancos.map((banco) => (
                    <MenuItem key={banco.id} value={String(banco.id)}>
                      {banco.nomban}
                    </MenuItem>
                  ))}
                </Select>

                {/* Aquí mostramos el texto de ayuda / error */}
                {errors.banco1Cli && (
                  <FormHelperText id="banco1-helper">{errors.banco1Cli}</FormHelperText>
                )}
              </FormControl>

              {/* Banco 2 */}
              <FormControl
                fullWidth
                // required
                error={Boolean(errors.banco2Cli)}
                sx={{ width: '300px' }}
              >
                <InputLabel id="banco2-label" sx={{ marginTop: '2px' }}>
                  Banco-2
                </InputLabel>

                <Select
                  labelId="banco2-label"
                  id="banco2-select"
                  value={banco2Cli}
                  label="Banco"
                  onChange={(e) => handleInputChange(e, 'banco2Cli')}
                  sx={{
                    height: 40,
                  }}
                >
                  <MenuItem 
                    value={''} 
                    sx={{ color: '#5A47B3', fontWeight: 'bold' }}
                  >
                    ✨ Seleccionar Banco
                  </MenuItem>
                  {bancos.map((banco) => (
                    <MenuItem key={banco.id} value={String(banco.id)}>
                      {banco.nomban}
                    </MenuItem>
                  ))}
                </Select>

                {/* Aquí mostramos el texto de ayuda / error */}
                {errors.banco2Cli && (
                  <FormHelperText id="banco2-helper">{errors.banco2Cli}</FormHelperText>
                )}
              </FormControl>

              {/* Banco 3 */}
              <FormControl
                fullWidth
                // required
                error={Boolean(errors.banco3Cli)}
                sx={{ width: '300px' }}
              >
                <InputLabel id="banco3-label" sx={{ marginTop: '2px' }}>
                  Banco-3
                </InputLabel>
                <Select
                  labelId="banco3-label"
                  id="banco3-select"
                  value={banco3Cli}
                  label="Banco"
                  onChange={(e) => handleInputChange(e, 'banco3Cli')}
                  sx={{
                    height: 40,
                  }}
                >
                  <MenuItem 
                    value={''} 
                    sx={{ color: '#5A47B3', fontWeight: 'bold' }}
                  >
                    ✨ Seleccionar Banco
                  </MenuItem>
                  {bancos.map((banco) => (
                    <MenuItem key={banco.id} value={String(banco.id)}>
                      {banco.nomban}
                    </MenuItem>
                  ))}
                </Select>

                {/* Aquí mostramos el texto de ayuda / error */}
                {errors.banco3Cli && (
                  <FormHelperText id="banco3-helper">{errors.banco3Cli}</FormHelperText>
                )}
              </FormControl>
            </div>

            <div className="mt-4 flex gap-4 justify-between text-sm text-teal-200">

              {/* Ctacte del Banco 1 de 3 */}
              <TextField
                label="Ctacte-1"
                value={ctacte1Cli}
                onChange={(e) => handleInputChange(e, 'ctacte1Cli')}
                fullWidth
                sx={{
                  marginBottom: 2,
                  '& .MuiInputBase-root': {
                    height: 40,
                  },
                }}
                error={Boolean(errors.ctacte1Cli)}
                helperText={errors.ctacte1Cli}
                autoComplete="off" // Desactivar autocompletado //
              />

              {/* Ctacte del Banco 2 de 3 */}
              <TextField
                label="Ctacte-2"
                value={ctacte2Cli}
                onChange={(e) => handleInputChange(e, 'ctacte2Cli')}
                fullWidth
                sx={{
                  marginBottom: 2,
                  '& .MuiInputBase-root': {
                    height: 40,
                  },
                }}
                error={Boolean(errors.ctacte2Cli)}
                helperText={errors.ctacte2Cli}
                autoComplete="off" // Desactivar autocompletado //
              />

              {/* Ctacte del Banco 3 de 3 */}
              <TextField
                label="Ctacte-3"
                value={ctacte3Cli}
                onChange={(e) => handleInputChange(e, 'ctacte3Cli')}
                fullWidth
                sx={{
                  marginBottom: 2,
                  '& .MuiInputBase-root': {
                    height: 40,
                  },
                }}
                error={Boolean(errors.ctacte3Cli)}
                helperText={errors.ctacte3Cli}
                autoComplete="off" // Desactivar autocompletado //
              />
            </div>

            {/* display: 'flex'. Esto coloca los botones uno al lado del otro. El gap: '8px' agrega un espacio de 8 píxeles entre los botones. */}
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}>
              <Button
                variant="contained"
                color="primary"
                disabled={!isFormValid} // ✅ Solo habilitado si las validaciones estan ok

                sx={{
                  width: '180px',
                  // padding: '6px 16px', // Ajustar padding para que los botones tengan el mismo tamaño //
                  height: '40px',
                  backgroundColor: '#8b888e', // Color de fondo inicial
                  color: 'white', // Color del texto en blanco
                  '&:hover': {
                    backgroundColor: 'red', // Cambia el color de fondo a verde al pasar el mouse //
                    color: 'white', // Cambia el color del texto a blanco //
                  }
                }}
                onClick={handleSave}>
                <RiSave3Fill className="m-2" style={{ fontSize: '1.5rem' }} /> {/* Aumento el tamaño del icono */}
                {editingCliente ? 'Regrabar' : 'Grabar'}
              </Button>

              <Button
                variant="outlined"
                sx={{
                  width: '180px',
                  // padding: '6px 16px', // Ajustar padding para que los botones tengan el mismo tamaño //
                  height: '40px', // Establece la altura constante //
                  backgroundColor: '#8b888e', // Color de fondo inicial
                  color: 'white', // Color del texto en blanco
                  '&:hover': {
                    backgroundColor: 'green', // Cambia el color de fondo a verde al pasar el mouse //
                    color: 'white', // Cambia el color del texto a blanco //
                  }
                }}
                onClick={handleCloseModal}>
                <RiReplyAllLine className="m-2" style={{ fontSize: '1.5rem' }} /> {/* Aumento el tamaño del icono */}
                Cancelar
              </Button>
            </div>
          </Box>
        </Modal>
      </Box>
    </div>
  );
};

export default Clientes;
